export default [
  {
    title: 'My Invoices',
    icon: 'FileTextIcon',
    name: 'my-invoices',
    route: 'UserMyInvoices',
    tagVariant: 'light-warning',
  },
]